import { c as _c } from "react/compiler-runtime";
import { faFlagCheckered, faSpinner } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { mergeTailwindClasses } from '@xefi/x-react/utils';
import { useTranslation } from 'react-i18next';
import { useMainStore } from '@/store';
type CompleteSurveyProps = {
  onPageChange: (next: boolean) => void;
  currentPage: number;
  totalPage: number;
  isSubmitting: boolean;
};
export const CompleteSurvey = t0 => {
  const $ = _c(17);
  const {
    onPageChange,
    currentPage,
    totalPage,
    isSubmitting
  } = t0;
  const {
    t
  } = useTranslation();
  const {
    canUserAnswerSurvey
  } = useMainStore();
  const isDisabled = currentPage !== totalPage || !canUserAnswerSurvey || isSubmitting;
  let t1;
  if ($[0] !== onPageChange) {
    t1 = () => onPageChange(true);
    $[0] = onPageChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = isDisabled ? "text-content1-300 dark:text-white/50!" : "text-primary";
  let t3;
  if ($[2] !== t2) {
    t3 = mergeTailwindClasses("text-sm", t2);
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t) {
    t4 = t("survey.stop");
    $[4] = t;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <span className={t3}>{t4}</span>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== isDisabled || $[10] !== isSubmitting) {
    t6 = isSubmitting ? <FontAwesomeIcon icon={faSpinner} spin={true} className="text-content1-300 dark:text-white/50!" /> : <FontAwesomeIcon icon={faFlagCheckered} className={mergeTailwindClasses("rotate-12 text-lg", isDisabled ? "text-content1-300 dark:text-white/50!" : "text-primary")} />;
    $[9] = isDisabled;
    $[10] = isSubmitting;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== isDisabled || $[13] !== t1 || $[14] !== t5 || $[15] !== t6) {
    t7 = <button disabled={isDisabled} onClick={t1} className="flex items-center gap-2 rounded-full">{t5}{t6}</button>;
    $[12] = isDisabled;
    $[13] = t1;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};